import { DomSanitizer, SafeHtml, SafeResourceUrl, SafeStyle } from '@angular/platform-browser';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SafeResourceUrlService {
  constructor(private readonly sanitizer: DomSanitizer) {}

  toSafeUrl(url: string): SafeResourceUrl {
    const absoluteUrl = this.makeAbsoluteUrl(url);
    const trusted = this.validateUrl(absoluteUrl);
    if (!trusted) throw new Error('Unsafe URL');
    return this.sanitizer.bypassSecurityTrustResourceUrl(absoluteUrl); //NOSONAR
  }

  toSafeStyle(url: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(url); //NOSONAR
  }

  toSafeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html); //NOSONAR
  }

  private makeAbsoluteUrl(url: string): string {
    if (this.isAbsoluteUrl(url)) {
      return url;
    }
    const currentOrigin = window.location.origin;
    return `${currentOrigin}${url.startsWith('/') ? url : '/' + url}`;
  }

  private isAbsoluteUrl(url: string): boolean {
    return this.parseUrl(url) !== null;
  }

  private validateUrl(url: string): boolean {
    //for :data:image
    if (url.startsWith('data:')) {
      return true;
    }
    const parsed = this.parseUrl(url);
    if (!parsed) return false;
    if (['https:', 'blob:'].includes(parsed.protocol)) {
      return true;
    }
    // Allow http protocol only for localhost
    if (parsed.protocol === 'http:' && (parsed.hostname === 'localhost' || parsed.hostname.startsWith('localhost:'))) {
      return true;
    }
    return false;
  }

  private parseUrl(url: string): URL | null {
    try {
      return new URL(url);
    } catch {
      return null;
    }
  }
}
